import { InventoryChangeReason } from "__graphql__/types";

import { StockUpdatePlan } from "../stores/inboundStore/types";

export const getTotalForReasons = (
  stockUpdatePlan: StockUpdatePlan[],
  reasons: InventoryChangeReason[],
): number => {
  return (
    stockUpdatePlan?.reduce(
      (sum: number, plan) =>
        reasons.includes(plan.reason) ? sum + (plan.quantityDelta ?? 0) : sum,
      0,
    ) ?? 0
  );
};

export const getNegativeTotalForReasons = (
  stockUpdatePlan: StockUpdatePlan[],
  reasons: InventoryChangeReason[],
) => -getTotalForReasons(stockUpdatePlan, reasons);
